.grid {
  display: grid;
  gap: 16px;
  padding-bottom: 40px;
  width: 100%;
}

.option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
}

@media (--reefer-media-tablet-max) {
  .grid {
    gap: 12px;
  }

  .option {
    padding: 12px 16px;
  }
}
